import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Alert} from "antd";

import {LoadingStatus} from "../../store/status";
import {userAC} from "../../store/branches/user/actionCreators";
import {WinStorage} from "../../services/AuthSrorage";
import {selectUserState} from "../../store/selectors";

import classes from "./Alert.module.scss";


type AlertNotification = "success" | "info" | "warning" | "error"

const UserAlert = () => {
    const {status} = useSelector(selectUserState);
    const dispatch = useDispatch();
    const errorMessage = WinStorage.getErrorMessage();

    const setTimer = () => {
        setTimeout(() => {
            dispatch(userAC.setUserLoadingStatus(LoadingStatus.NEVER));
            WinStorage.removeErrorMessage();
        }, 10000);
    };

    const alertNotification = (message: typeof errorMessage | string, type: AlertNotification) => {
        return <Alert
            message={message}
            type={type}
            showIcon
            closable
            className={classes.alert}
        />;
    };

    if (status === LoadingStatus.ADD_USER_SUCCESS) {
        setTimer();
        return alertNotification(errorMessage || "User added successfully", "success");
    }


    if (status === LoadingStatus.ADD_USER_ERROR) {
        setTimer();
        return alertNotification(errorMessage || "The email address is already registered.", "warning");
    }

    if (status === LoadingStatus.UPDATED_USER_SUCCESS) {
        setTimer();
        return alertNotification(errorMessage || "User update successfully", "success");
    }

    if (status === LoadingStatus.UPDATED_USER_PASSWORD_SUCCESS) {
        setTimer();
        return alertNotification(errorMessage || "New password has been saved", "success");
    }

    if (status === LoadingStatus.UPDATED_USER_PASSWORD_ERROR) {
        setTimer();
        return alertNotification(errorMessage || "An error occured, please try again!", "warning");
    }

    if (status === LoadingStatus.UPDATED_USER_ERROR) {
        setTimer();
        return alertNotification(errorMessage || "An error occured, please try again!", "warning");
    }

    if (status === LoadingStatus.SEND_FEEDBACK_ERROR) {
        setTimer();
        return alertNotification(errorMessage || "An error occured, please try again!", "warning");
    }

    if (status === LoadingStatus.SEND_FEEDBACK_SUCCESS) {
        setTimer();
        return alertNotification("Your feedback has been saved successfully.", "success");
    }

    if (status === LoadingStatus.ADD_EMAIL_NOTIFICATION_WITHOUT_DEVICE_ERROR) {
        setTimer();
        return alertNotification(errorMessage || "Please select All Devices or select one of devices!", "warning");
    }
    if (status === LoadingStatus.TWO_FACTOR_SETUP) {
        setTimer();
        return alertNotification("Device registered, please verify by entering the token displayed on your device", "success");
    }
    if (status === LoadingStatus.TWO_FACTOR_VERIFIED) {
        setTimer();
        return alertNotification("Two factor set up complete", "success");
    }
    if (status === LoadingStatus.TWO_FACTOR_FAILED) {
        setTimer();
        return alertNotification("Device verification failed, please try again!", "warning");
    }
    if (status === LoadingStatus.TWO_FACTOR_DISABLED) {
        setTimer();
        return alertNotification("Two factor disabled", "success");
    }
    if (status === LoadingStatus.TWO_FACTOR_DISABLED_FAILED) {
        setTimer();
        return alertNotification("Failed disabling 2FA, please try again!", "warning");
    }


      
    return null;
};
export default UserAlert;
